import { get, isEmpty, isPojo } from '../../utilities'
import ArrayAttr from './ArrayAttr'
import ObjAttr from './ObjAttr'
import OptionalAttr from './OptionalAttr'

export default class Level {

    constructor(model, 
        components,
        style) {
        this.model = model
        this.components = components
        this.style = style
        this.include = {}
        this.exclude = {}
        this.parameters = this.style.parameters

        if (this.style.include) {
            this.include = this.mapArrayToObject(this.style.include)
        }
        if (this.style.exclude) {
            this.exclude = this.mapArrayToObject(this.style.exclude)
        }

        return this
    }

    build() {
        var str = this.buildParams()
        str += this.paginate(this.buildKeys())
        str += '}'
        return str
    }

    buildKeys() {
        var str = ''
        const fields = this.model.fields()
        Object.keys(fields).forEach((name) => {
            const field = fields[name]
            if (this.isExcluded(name)) {
                return
            }
            else if (this.isRelation(field)) {
                str += this.buildRelation(field, name)
            }
            else if (this.isArray(field) || this.isObj(field) || this.isOptional(field)) {
                str += this.buildCustom(field, name)
            }
            else {
                str += name
            }
            str += ' '
        })
        if (this.style.extra) str += this.style.extra + ' '
        return str
    }

    buildRelation(field, name) {
        if (!get(this.include, name)) return ''
        const modelObj = this.getRelatedModel(field)
        const level = new this.constructor(modelObj,
            this.components, 
            {
                type: name,
                include: get(this.include, name),
                exclude: get(this.exclude, name),
                parameters: get(this.parameters, name)
            })
        return level.build()
    }

    buildCustom(field, name) {
        if (!get(this.include, name)) return ''
        return field.toString(name)
    }

    schemaName() {
        return get(this, 
            'style.type', 
            this.model.entity)
    }

    buildParams() {
        const parameters = this.style.parameters
        var str = this.schemaName()
        if (!isEmpty(parameters)) {
            str += '('
            str += Object.keys(parameters)
                .filter(key => !isPojo(parameters[key]))
                .map((key) => key+': $'+key)
                .join(',')
            str += ')'
        }
        str += ' { '
        return str
    }

    paginate(value) {
        if (this.style.paginated) {
            return 'data { ' + value + ' } total'
        }
        return value
    }

    isArray(field) {
        return field instanceof ArrayAttr
    }

    isObj(field) {
        return field instanceof ObjAttr
    }

    isOptional(field) {
        return field instanceof OptionalAttr
    }

    isRelation(field) {
        return (
            field instanceof this.components.BelongsToMany ||
            field instanceof this.components.BelongsTo ||
            field instanceof this.components.HasOne ||
            field instanceof this.components.HasMany ||
            field instanceof this.components.MorphTo ||
            field instanceof this.components.MorphOne ||
            field instanceof this.components.MorphMany
        )
    }

    isExcluded(field) {
        const val = get(this.exclude, field)
        if (val) {
            return !(isPojo(val) || Array.isArray(val))
        }
        return false
    }

    getRelatedModel(relation) {
        if (relation === undefined) return null

        if (
            relation instanceof this.components.BelongsToMany ||
            relation instanceof this.components.HasMany ||
            relation instanceof this.components.HasManyThrough ||
            relation instanceof this.components.MorphedByMany ||
            relation instanceof this.components.MorphMany ||
            relation instanceof this.components.MorphOne ||
            relation instanceof this.components.MorphToMany ||
            relation instanceof this.components.HasOne
        ) {
            return this.components.Query.getModel(relation.related.entity, true)
        } 
        else if (
            relation instanceof this.components.BelongsTo ||
            relation instanceof this.components.HasManyBy
        ) {
            return this.components.Query.getModel(relation.parent.entity, true);
        } 
        else if (relation instanceof this.components.MorphTo) {
            return this.components.Query.getModel(relation.type, true);
        } 
        else {
            throw new Error(`Can't find related model for relation of type ${typeof relation}!`);
        }
    }

    mapArrayToObject(items) {
        var temp = {}
        if (Array.isArray(items)) {
            for (var item of items) {
                temp[item] = true
            }
        }
        else {
            temp = items
        }
        return temp
    }
}